import { authentication } from "../../app-database";
import { servicios } from "../../properties";
import { saveAs } from "file-saver";

export class callService {
  url = null;

  options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "",
    },
    body: "",
    secure: false,
    timeout: 20000,
  };

  constructor(_options, _callback, _callbackError) {
    if (!_options) _options = {};

    if (_options.service != undefined && !_options.rawUrl) {
      let url = null;
      _options.service.split(".").map(function (item) {
        url = url == null ? servicios[item] : url[item];
      });
      this.service = _options.service;
      this.url = url;
    } else {
      this.service = _options.service;
      this.url = _options.service;
    }

    if (_options.secure || _options.token != undefined) {
      this.options.secure = true;
    }

    if (_options.data != undefined) {
      this.options.body =
        typeof _options.data == "object"
          ? JSON.stringify(_options.data)
          : _options.data;
    }

    if(_options.method) {
      this.options.method = _options.method;
    }

    if(this.options.method == 'GET') {
      delete this.options.body;
    }

    if (_options.timeout != undefined) {
      this.options.timeout = _options.timeout;
    }
  }

  setData = (_data) => {
    this.options.headers.body = _data;
  };

  setToken = (_tid) => {
    this.options.headers.Authorization = "Bearer " + localStorage.getItem("refreshToken");
  };

  getToken = () => {
    let $this = this;
    return new Promise(function (resolve, reject) {
      if ($this.options.secure && authentication.currentUser) {
        authentication.currentUser
          .getIdToken()
          .then((token) => {
            $this.options.headers.Authorization = "Bearer " + localStorage.getItem("refreshToken");
            resolve(token);
          })
          .catch((error) => {
            reject(error);
          });
      } else {
        resolve(null);
      }
    });
  };

  execute = () => {
    let $this = this;
    return new Promise(function (resolve, reject) {
      if ($this.service != "user.accion") {
        console.log("URL: ",$this.url);
        console.log("BODY: ",$this.options.body);
      }

      $this.getToken().then((token) => {
        fetch($this.url, $this.options)
          .then(function (response) {
            $this.status = response.status;
            if (response.status == 200) {
              return response.json();
            } else if (response.status == 403) {
              return Promise.reject(response.json());
            } else {
              var error = new Error(response.statusText || response.status);
              error.response = response;
              return Promise.reject(error);
            }
          })
          .then(function (responseJson) {
            resolve(responseJson);
          })
          .catch(function (responseError) {
            try {
              responseError
                .then((error) => {
                  let errorOut =
                    error.code && error.message
                      ? {
                          message: {
                            codigoError: error.code,
                            mensaje: error.message,
                          },
                        }
                      : error.message
                      ? {
                          message: {
                            codigoError: "ERROR",
                            mensaje: error.message,
                          },
                        }
                      : error.body && error.body.Fault
                      ? { message: error.body.Fault.detail.eotException }
                      : Object.assign(error, {
                          message: {
                            codigoError: "ERROR",
                            mensaje: JSON.stringify(error),
                          },
                          error: error,
                        });
                  reject(errorOut);
                })
                .catch((error) => {
                  reject(error);
                });
            } catch (error) {
              reject({
                status: $this.status,
                stack: responseError.stack,
                message: {
                  mensaje: responseError.message,
                  codigoError: responseError.stack,
                },
              });
            }
          });
      });
    });
  };
}

export function formatPhone(_numero) {
  let numero = _numero != undefined ? _numero : "";
  numero = numero.replace("+", "");
  return numero;
}

export function formatDate(_timestamp) {
  let timestamp =
    _timestamp != undefined && _timestamp != "" ? _timestamp : null;
  let sDate = new Date(timestamp).toISOString().split("T")[0];
  sDate = sDate.split("-").join("");
  return sDate;
}

export function fnToSlash(_data) {
  return _data != undefined ? _data.replace(/-/g, "/") : "";
}

export function formatDateDMA(_timestamp) {
  let timestamp =
    _timestamp != undefined && _timestamp != "" ? _timestamp : null;
  let sDate = new Date(timestamp).toISOString().split("T")[0];
  sDate = sDate.split("-").reverse().join("/");
  return sDate;
}

export function formatDateSSRep(_date) {
  let date = _date != undefined && _date != "" ? _date : null;
  date = date.split("/").reverse().join("-");
  return date;
}

export function formatRamo(_ramo) {
  let sRamo = _ramo != undefined && _ramo != "" ? _ramo : "A";
  sRamo = sRamo.substr(0, 1).toUpperCase();
  return sRamo;
}

export function formatClienteUnico(_uid) {
  var sClienteUnico = "" + _uid;
  while (sClienteUnico.length < 10) {
    sClienteUnico = "0" + sClienteUnico;
  }

  return sClienteUnico;
}

export function existeFecha(dia, mes, anio) {
  var date = new Date(anio, mes, "0");
  if (dia - 0 > date.getDate() - 0) {
    return false;
  }
  return true;
}

export function makeform(_url, _campos, _method) {
  _method = _method || "post";

  var form = document.createElement("form");
  form.setAttribute("target", "_self");
  form.setAttribute("method", _method);
  form.setAttribute("action", _url);

  for (var key in _campos) {
    if (_campos.hasOwnProperty(key)) {
      var field = document.createElement("input");
      field.setAttribute("type", "hidden");
      field.setAttribute("name", key);
      field.setAttribute("value", _campos[key]);
      form.appendChild(field);
    }
  }

  if (document.getElementById("virtualForm") == null) {
    let virtualForm = document.createElement("div");
    virtualForm.setAttribute("id", "virtualForm");
    virtualForm.setAttribute("style", "display:none");
    document.body.appendChild(virtualForm);
  }

  document.getElementById("virtualForm").appendChild(form);
  form.submit();
}

export function downloadCertificadoEco(certificado, numPoliza, sArchivo) {
  var id = new Date().getTime();
  var sArchivo =
    sArchivo.length > 50 ? sArchivo.substr(0, 50) + "..." : sArchivo;
  var redux = angular.element(document.querySelector("ui-view")).scope().$parent
    .state.redux;
  redux.dispatch({
    type: "DESCARGAS_LISTA_ADD",
    descarga: { id: id, nombre: sArchivo, completo: 0 },
  });

  var req = new XMLHttpRequest();
  var url = `${servicios.descargas.certificadoECO}?certificado=${certificado}&numPoliza=${numPoliza}`;
  console.log(
    `servicios.descargas.certificadoECO => ${servicios.descargas.certificadoECO}`
  );
  console.log(`url => ${url}`);

  var body = {
    numPoliza: numPoliza,
    certificado: certificado,
  };

  req.open("POST", url, true);
  req.setRequestHeader("Content-Type", "application/json");
  req.addEventListener(
    "progress",
    function (evt) {
      if (evt.lengthComputable) {
        var percentComplete = (evt.loaded / evt.total) * 100;
        redux.dispatch({
          type: "DESCARGAS_LISTA_UPDATE",
          descarga: { id: id, nombre: sArchivo, completo: percentComplete },
        });
      }
    },
    false
  );
  req.onreadystatechange = function () {
    if (req.readyState === 4 && req.status === 200) {
      redux.dispatch({
        type: "DESCARGAS_LISTA_UPDATE",
        descarga: { id: id, nombre: sArchivo, completo: 100 },
      });
      console.log("req: ", req);
      var body = JSON.parse(req.response);
      const linkSource = `data:application/pdf;base64,${body.contenido}`;
      const downloadLink = document.createElement("a");
      const fileName = `Póliza_${numPoliza}.pdf`;
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    } else if (req.status == 500) {
      console.log("req error:", req);
      redux.dispatch({
        type: "DESCARGAS_LISTA_UPDATE",
        descarga: { id: id, nombre: sArchivo, completo: 100, error: true },
      });
      redux.dispatch({
        type: "MODAL_ALERT_MESSAGES_SHOW",
        titulo: "Importante",
        mensaje:
          "Por el momento no es posible mostrar la documentación. Por favor, contacte a su Asesor Profesional en Seguros para solicitar la información.",
      });
    }
  };
  req.send(JSON.stringify(body));
}

export function download(sDocumento, sTipo, sArchivo, callback) {
  var redux = angular.element(document.querySelector("ui-view")).scope().$parent
    .state.redux;
  var page_url =
    servicios.facturas.descargaFactura +
    "?idDocumento=" +
    sDocumento +
    "&tipo=" +
    sTipo;

  var req = new XMLHttpRequest();
  req.open("GET", page_url, true);
  req.setRequestHeader("access", "*/*");
  req.addEventListener(
    "progress",
    function (evt) {
      if (evt.lengthComputable) {
        redux.dispatch({
          type: "DOWNLOADING",
          progress: evt.loaded / evt.total,
        });
      }
    },
    false
  );

  req.responseType = "blob";
  req.onreadystatechange = function () {
    if (req.readyState === 4 && req.status === 200) {
      redux.dispatch({ type: "DOWNLOADED" });

      var filename = sArchivo;
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(req.response);
      link.download = filename;
      link.click();

      if (callback) {
        callback(sDocumento);
      }
    } else if (req.status == 504) {
      redux.dispatch({ type: "DOWNLOADED" });
      redux.dispatch({ type: "DOWNLOADING", progress: 0 });

      if (callback) {
        callback(sDocumento, true);
      }
    }
  };
  req.send();
}

export function descargasBinary(sUrl, sArchivo) {
  var id = new Date().getTime();
  var sArchivo =
    sArchivo.length > 50 ? sArchivo.substr(0, 50) + "..." : sArchivo;
  var redux = angular.element(document.querySelector("ui-view")).scope().$parent
    .state.redux;

  redux.dispatch({
    type: "DESCARGAS_LISTA_ADD",
    descarga: { id: id, nombre: sArchivo, completo: 0 },
  });

  var req = new XMLHttpRequest();
  req.open("GET", sUrl, true);
  req.addEventListener(
    "progress",
    function (evt) {
      if (evt.lengthComputable) {
        var percentComplete = (evt.loaded / evt.total) * 100;
        redux.dispatch({
          type: "DESCARGAS_LISTA_UPDATE",
          descarga: { id: id, nombre: sArchivo, completo: percentComplete },
        });
      }
    },
    false
  );
  req.onreadystatechange = function () {
    if (req.readyState === 4 && req.status === 200) {
      var value = JSON.parse(req.response);
      var binaryString = window.atob(value.getObjectResponse.archivo);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }

      var newBlob = new Blob([bytes], { type: "application/pdf" });

      redux.dispatch({
        type: "DESCARGAS_LISTA_UPDATE",
        descarga: { id: id, nombre: sArchivo, completo: 100 },
      });
      saveAs(newBlob, sArchivo);
    } else if (
      req.readyState === 4 &&
      (req.status === 500 || req.status === 403)
    ) {
      redux.dispatch({
        type: "DESCARGAS_LISTA_UPDATE",
        descarga: { id: id, nombre: sArchivo, completo: 100, error: true },
      });
      redux.dispatch({
        type: "MODAL_ALERT_MESSAGES_SHOW",
        titulo: "Importante",
        mensaje:
          "Por el momento no es posible mostrar la documentación. Por favor, contacte a su Asesor Profesional en Seguros para solicitar la información.",
      });
    }
  };
  req.send();
}

export function descargas(sUrl, sArchivo) {
  var id = new Date().getTime();
  var sArchivo =
    sArchivo.length > 50 ? sArchivo.substr(0, 50) + "..." : sArchivo;
  var redux = angular.element(document.querySelector("ui-view")).scope().$parent
    .state.redux;

  redux.dispatch({
    type: "DESCARGAS_LISTA_ADD",
    descarga: { id: id, nombre: sArchivo, completo: 0 },
  });

  var req = new XMLHttpRequest();
  req.open("GET", sUrl, true);
  req.addEventListener(
    "progress",
    function (evt) {
      if (evt.lengthComputable) {
        var percentComplete = (evt.loaded / evt.total) * 100;
        redux.dispatch({
          type: "DESCARGAS_LISTA_UPDATE",
          descarga: { id: id, nombre: sArchivo, completo: percentComplete },
        });
      }
    },
    false
  );
  req.responseType = "blob";
  req.onreadystatechange = function () {
    if (req.readyState === 4 && req.status === 200) {
      redux.dispatch({
        type: "DESCARGAS_LISTA_UPDATE",
        descarga: { id: id, nombre: sArchivo, completo: 100 },
      });

      if (typeof window.chrome !== "undefined") {
        // Chrome version
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(req.response);
        link.download = sArchivo;
        link.click();
      } else if (typeof window.navigator.msSaveBlob !== "undefined") {
        // IE version
        var blob = new Blob([req.response], {
          type: "application/force-download",
        });
        window.navigator.msSaveBlob(blob, sArchivo);
      } else {
        // Firefox version
        var file = new File([req.response], sArchivo, {
          type: "application/force-download",
        });
        var linkOpen = document.createElement("a");
        linkOpen.href = window.URL.createObjectURL(file);
        linkOpen.download = sArchivo;
        linkOpen.click();
      }
    } else if (
      req.readyState === 4 &&
      (req.status === 500 || req.status === 403)
    ) {
      redux.dispatch({
        type: "DESCARGAS_LISTA_UPDATE",
        descarga: { id: id, nombre: sArchivo, completo: 100, error: true },
      });
      redux.dispatch({
        type: "MODAL_ALERT_MESSAGES_SHOW",
        titulo: "Importante",
        mensaje:
          "Por el momento no es posible mostrar la documentación. Por favor, contacte a su Asesor Profesional en Seguros para solicitar la información.",
      });
    }
  };
  req.send();
}

export function setCookie(numPoliza) {
  let caducidad = 1; // 1 dia
  let expireDate = new Date();

  expireDate.setDate(expireDate.getDate() + caducidad);
  document.cookie =
    "poliza=" +
    escape(numPoliza) +
    "; expires=" +
    expireDate.toGMTString() +
    ";  domain=gnp.com.mx; path=/";
}

export function goTo(sState) {
  let angularInstance = angular.element(document.querySelector("ui-view"));
  angularInstance.injector().get("$location").path(sState);

  //angularInstance.scope().$apply();

  if (!angularInstance.scope().$$phase) {
    angularInstance.scope().$apply();
  }

  window.scrollTo(0, 0);
}

export function fnMoneda(value, decimals = 2, separators = [",", ",", "."]) {
  decimals = decimals >= 0 ? parseInt(decimals, 0) : 2;
  separators = separators || [".", "'", ","];

  let number = (parseFloat(value) || 0).toFixed(decimals);

  if (number.length <= 4 + decimals) {
    return number.replace(".", separators[separators.length - 1]);
  } else {
    let parts = number.split(/[-.]/);
    value = parts[parts.length > 1 ? parts.length - 2 : 0];

    let result =
      value.substr(value.length - 3, 3) +
      (parts.length > 1
        ? separators[separators.length - 1] + parts[parts.length - 1]
        : "");
    let start = value.length - 6,
      idx = 0;

    while (start > -3) {
      result =
        (start > 0 ? value.substr(start, 3) : value.substr(0, 3 + start)) +
        separators[idx] +
        result;
      idx = ++idx % 2;
      start -= 3;
    }

    return (parts.length == 3 ? "-" : "") + result;
  }
}

export function setCookiePortal(numPoliza) {
  let caducidad = 1; // 1 dia
  let expireDate = new Date();
  expireDate.setDate(expireDate.getDate() + caducidad);
  document.cookie =
    "polizaSoyCliente=" +
    escape(numPoliza) +
    "; expires=" +
    expireDate.toGMTString() +
    ";  domain=gnp.com.mx; path=/";
}

window.goToTest = function (_url) {
  goTo(_url);
};



// WEBPACK FOOTER //
// ./src/seguimiento-siniestros/seguimientoSiniestro/segimientoSiniestroTools.js